// Every salon-app axios request goes through the shared axios default, and the
// portal/admin apps use raw fetch. Without a timeout, a request that opens a
// socket but never answers (a hung staging worker, a dropped mobile connection)
// leaves the calling spinner on screen forever. These are the single guards at
// each transport boundary.
export const DEFAULT_HTTP_TIMEOUT_MS = 45000;

export const applyDefaultHttpTimeout = (client, timeout = DEFAULT_HTTP_TIMEOUT_MS) => {
  // Axios initializes this to 0 (unlimited), rather than leaving it unset.
  if (client && client.defaults && (client.defaults.timeout == null || client.defaults.timeout === 0)) {
    client.defaults.timeout = timeout;
  }
  return client;
};

// A hard timeout for raw fetch calls: it rejects on the deadline even if the
// request ignores the abort, and still honours a caller-supplied signal.
export const fetchWithTimeout = (url, options = {}, timeoutMs = DEFAULT_HTTP_TIMEOUT_MS) =>
  new Promise((resolve, reject) => {
    const controller = new AbortController();
    const callerSignal = options.signal;
    const onCallerAbort = () => controller.abort();
    if (callerSignal) {
      if (callerSignal.aborted) controller.abort();
      else callerSignal.addEventListener("abort", onCallerAbort);
    }
    const finish = (fn, value) => {
      clearTimeout(timer);
      if (callerSignal) callerSignal.removeEventListener("abort", onCallerAbort);
      fn(value);
    };
    const timer = setTimeout(() => {
      controller.abort();
      finish(reject, new Error("Request timed out."));
    }, timeoutMs);
    Promise.resolve()
      .then(() => fetch(url, { ...options, signal: controller.signal }))
      .then(
        (response) => finish(resolve, response),
        (error) => finish(reject, error),
      );
  });
